export default __webpack_public_path__ + "static/media/Filter.cec55798.svg";